import React from 'react';
import { Subheader } from 'material-ui';
import typography from 'material-ui/styles/typography';
import { white } from 'material-ui/styles/colors';
import { IconButton, Tooltip } from '@material-ui/core';
import MailOutlineSharpIcon from '@material-ui/icons/MailOutlineSharp';
import PropTypes from 'prop-types';
import DataTable from '../../../widgets/data-table/DataTable/DataTable';
import columns from './customer-renewal-columns';
import DataTablePagination from '../../../widgets/data-table/DataTable/DataTablePagination/DataTablePagination';
import './CustomerRenewalTable.css';
import { Visibility, Info, NotInterested } from '@material-ui/icons';
import { injectIntl } from 'react-intl';
import * as RenewalStatus from '../../../../constants/RenewalStatus';

const showInfoButton = (renewal) =>
  !!renewal &&
  (renewal.status === RenewalStatus.IN_PROGRESS.name ||
    renewal.status === RenewalStatus.APPROVAL_REQUIRED.name) &&
  renewal.validationErrors.length > 0;

const mappedColumns = (
  columns,
  sortRequest,
  sortBy,
  custClick,
  resendSignatureEmailClick,
  props
) => [
  // Give the column header sort by functions.
  ...columns.map((column) => ({
    ...column,
    header: {
      ...column.header,
      onRequestSort: () =>
        column.header.sortBy ? sortRequest(column.header.sortBy) : () => {},
      isSortedBy: () => sortBy.name === column.header.sortBy
    }
  })),
  // Add column with icons for viewing either validations or the renewal.
  {
    header: {
      display: ''
    },
    accessor: (customer) => {
      let exclusionReason = 'customer_contract_not_viewable';
      const isRenewalEligible =
        !!customer.contract &&
        !customer.contract.hasGeneralPriceListProduct &&
        !customer.contract.hasExcludedProducts &&
        !customer.contract.hasExcludedSRCTypes;

      if (!isRenewalEligible) {
        if (customer.contract.hasGeneralPriceListProduct)
          exclusionReason = 'customer_uses_general_price_list';
        else if (customer.contract.hasExcludedProducts)
          exclusionReason = 'customer_uses_excluded_product';
        else if (customer.contract.hasExcludedSRCTypes)
          exclusionReason = 'customer_uses_excluded_src_types';
      }

      let awaitingCustomerSignature =
        RenewalStatus[customer.renewalStatus].name ===
        RenewalStatus.CUSTOMER_APPROVAL_REQUIRED.name;

      return {
        display: (
          <div style={{ float: 'right', textAlign: 'right' }}>
            {showInfoButton(customer.renewal) ? (
              <Tooltip
                title={props.intl.formatMessage({
                  id: 'renewal_requires_approval'
                })}
                placement="left"
              >
                <IconButton iconclassname="details-icon material-icons">
                  <Info />
                </IconButton>
              </Tooltip>
            ) : null}
            {!isRenewalEligible ? (
              <Tooltip
                title={props.intl.formatMessage({
                  id: exclusionReason
                })}
                placement="top"
              >
                <IconButton
                  className="ineligible-button"
                  iconclassname="material-icons"
                  label="Product Details"
                >
                  <NotInterested />
                </IconButton>
              </Tooltip>
            ) : null}
            {awaitingCustomerSignature ? (
              <Tooltip
                title={props.intl.formatMessage({
                  id: 'resend_signature_email'
                })}
                placement="top"
              >
                <span>
                  <IconButton
                    onClick={() => resendSignatureEmailClick(customer)}
                  >
                    <MailOutlineSharpIcon />
                  </IconButton>
                </span>
              </Tooltip>
            ) : null}
            <IconButton
              className="details-button"
              iconclassname="details-icon material-icons"
              label={props.intl.formatMessage({ id: 'product_details' })}
              onClick={() => custClick(customer.branchRouteCustomerId)}
            >
              <Visibility />
            </IconButton>
          </div>
        ),
        ignoreOnClick: true
      };
    }
  }
];

// Give each row an on-click function.
const mappedCustomers = (customers, custClick) =>
  customers.map((customer) => {
    const isRenewalEligible =
      !!customer.contract && !customer.contract.hasGeneralPriceListProduct;

    return {
      ...customer,
      onClick: isRenewalEligible
        ? () => custClick(customer.branchRouteCustomerId)
        : customer.onClick
    };
  });

const CustomerRenewalTable = (props) => (
  <div className="row">
    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15 ">
      <Subheader
        style={{
          fontSize: 24,
          fontWeight: typography.fontWeightLight,
          backgroundColor: '#3e4757',
          color: white,
          margin: '20px 0px 0px 0px'
        }}
      >
        {props.title}
      </Subheader>
      <DataTable
        columns={mappedColumns(
          columns(props),
          props.handleRequestSort,
          props.sortBy,
          props.handleClickCustomer,
          props.handleResendSignatureEmail,
          props
        )}
        bodyData={mappedCustomers(props.customers, props.handleClickCustomer)}
        direction={props.sortBy.direction}
        footerContent={
          <DataTablePagination
            page={props.page}
            onChangePage={props.handleChangePage}
            onChangeRowsPerPage={props.handleChangeRowsPerPage}
          />
        }
      />
    </div>
  </div>
);

CustomerRenewalTable.propTypes = {
  customers: PropTypes.array,
  title: PropTypes.string,
  page: PropTypes.object,
  sortBy: PropTypes.object,
  handleRequestSort: PropTypes.func,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  handleClickCustomer: PropTypes.func
};

export default injectIntl(CustomerRenewalTable);
